import React, { useMemo } from 'react';
import { ColDef } from 'ag-grid-community';
import { MaterialColor } from '../types/CommonTypes';
import ConditionList from './ConditionList';

interface Props {
    colors: MaterialColor[];
    onSelect: (color: MaterialColor) => void;
    loading?: boolean;
}

const columnDefs: ColDef<MaterialColor>[] = [
    { headerName: 'Code', field: 'code', flex: 60 },
    { headerName: 'Legacy Code', field: 'legacyCode', flex: 60 },
    { headerName: 'Label', field: 'colorLabel', flex: 100 },
    { headerName: 'Color', field: 'color', flex: 80 },
];

export default function ColorList({ colors, onSelect, loading }: Props): JSX.Element {
    return <ConditionList rows={colors} columnDefs={columnDefs} onSelect={onSelect} loading={loading} />;
}
